import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { BillingPage } from "@/features/billing/pages/billing-page/billing-page";
import { billingFiltersSchema } from "@/features/billing/schemas/billing-filters/billing-filters.schema";

export const Route = createFileRoute("/_authenticated/admin/billing/")({
	head: () => pageTitle("Billing"),
	validateSearch: zodValidator(billingFiltersSchema),
	component: RouteComponent,
});

function RouteComponent() {
	return <BillingPage />;
}
